import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('EmailIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="icon icon__email" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.38 17.73">
        <path className="foreground" d="M23.6,17.73H.78L8.87,9.64l3.32,2.55,3.32-2.55Zm.78-.78V2.77h0l-8,6.09ZM0,17V2.77L8,8.86,0,17ZM24.38,1.44V0H0V1.44l12.19,9.31Z"/>
      </svg>
    ), el);
  });
};
